module.exports = __webpack_public_path__ + "static/img/emblem.e9174a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/emblem.svg
// module id = Lce3
// module chunks = 1